import { store } from "../store/store";

export const logUpdateDataPatient = (patientName, dataOld, dataNew, userUpd, IP) => {
    const reduxState = store.getState().company;
    const db = reduxState?.companyInstance?.db;

    db.collection("log")
        .doc("logPatient")
        .collection("updatePatient")
        .add({
            action: "[Doctor] Update User",
            patientOld: dataOld,
            patientNew: dataNew,
            patientDNI: dataOld.patientDNI,
            patientName: patientName,
            updateRol: userUpd.typeUser,
            updateBy: userUpd.nameComplete,
            updateByDNI: userUpd.dni,
            updateDate: new Date(),
            ip: IP.IPv4,
            country: IP.country_name
        });
}